import React, { useContext, useState, useEffect, useRef } from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import { Box, Fade } from "@mui/material";
import './sidebar.css';
import AddIcon from '@mui/icons-material/Add';
import ChatIcon from '@mui/icons-material/Chat';
import DeleteIcon from '@mui/icons-material/Delete';
import { dataContext } from '../context/userContect';
import { Link } from 'react-router-dom';
import AlbumIcon from '@mui/icons-material/Album';
import UserProfile from '../profile/UserProfile';
import { useAuth } from '../../context/AuthContext';
import CloseIcon from '@mui/icons-material/Close';

function Sidebar() {
    const [extend, setExtend] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);
    const [isTablet, setIsTablet] = useState(window.innerWidth <= 768 && window.innerWidth > 600);
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const { sent, previousPrompt, newChat, setPerviousPrompt } = useContext(dataContext);
    const { currentUser } = useAuth();
    const sidebarRef = useRef(null);

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;
            setIsMobile(width <= 600);
            setIsTablet(width <= 768 && width > 600);
            
            if (width > 600) {
                setSidebarOpen(false);
                document.body.classList.remove('sidebar-open');
            }
        };

        const handleClickOutside = (event) => {
            if (sidebarOpen && sidebarRef.current && !sidebarRef.current.contains(event.target)) {
                // Check if the click was on the mobile toggle button
                const toggleButton = document.querySelector('.mobile-menu-toggle');
                if (toggleButton && !toggleButton.contains(event.target)) {
                    toggleSidebar();
                }
            }
        };

        const handleToggleSidebar = () => {
            setSidebarOpen(prev => !prev);
            if (sidebarOpen) {
                document.body.classList.remove('sidebar-open');
            } else {
                document.body.classList.add('sidebar-open');
            }
        };

        window.addEventListener('resize', handleResize);
        window.addEventListener('toggleSidebar', handleToggleSidebar);
        document.addEventListener('mousedown', handleClickOutside);
        
        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('toggleSidebar', handleToggleSidebar);
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [sidebarOpen]);

    const toggleSidebar = () => {
        setSidebarOpen(prev => !prev);
        if (!sidebarOpen) {
            document.body.classList.add('sidebar-open');
        } else {
            document.body.classList.remove('sidebar-open');
        }
    };

    async function loadPrevPrompt(params) {
        sent(params);
        if (isMobile) {
            setSidebarOpen(false);
            document.body.classList.remove('sidebar-open');
        }
    }

    const deleteChat = (index) => {
        const updatedPrompts = previousPrompt.filter((_, i) => i !== index);
        setPerviousPrompt(updatedPrompts);
    };

    return (
        <>
            <Fade in={isMobile}>
                <Box className="mobile-menu-toggle" onClick={toggleSidebar}>
                    {sidebarOpen ? <CloseIcon /> : <MenuIcon />}
                </Box>
            </Fade>
            
            <Box 
                ref={sidebarRef}
                className={`sidebar ${sidebarOpen ? 'open' : ''}`}
            >
                <Box 
                    id="menu" 
                    onClick={isMobile || isTablet ? toggleSidebar : () => setExtend(!extend)}
                >
                    {sidebarOpen && isMobile ? <CloseIcon /> : <MenuIcon />}
                </Box>

                {/* Fixed Navigation Items */}
                <Box className="sidebar-fixed-nav">
                    <Box 
                        className='sidebar-menu-item' 
                        onClick={() => {
                            newChat();
                            if (isMobile) {
                                setSidebarOpen(false);
                                document.body.classList.remove('sidebar-open');
                            }
                        }}
                    >
                        <AddIcon />
                        {(extend || !isTablet || (isMobile && sidebarOpen)) && <p>New Chat</p>}
                    </Box>

                    <Link to='/Aivoice' className='sidebar-menu-item'>
                        <AlbumIcon />
                        {(extend || !isTablet || (isMobile && sidebarOpen)) && <p>AI Voice</p>}
                    </Link>
                </Box>

                {/* Scrollable Recent Chats */}
                {previousPrompt.length > 0 && (
                    <>
                        {(extend || !isTablet || (isMobile && sidebarOpen)) && (
                            <Box className="sidebar-section-title">
                                <p>Recent Chats</p>
                            </Box>
                        )}
                        <Box className="recent-chats-container">
                            {previousPrompt.map((item, index) => (
                                <Box 
                                    key={index} 
                                    className='sidebar-menu-item chat-item'
                                >
                                    <Box 
                                        className="chat-content"
                                        onClick={() => loadPrevPrompt(item)}
                                    >
                                        <ChatIcon />
                                        {(extend || !isTablet || (isMobile && sidebarOpen)) && (
                                            <p>{item.slice(0, 10) + (item.length > 2 ? "..." : "")}</p>
                                        )}
                                    </Box>
                                    {(extend || !isTablet || (isMobile && sidebarOpen)) && (
                                        <Box 
                                            className="delete-chat-btn"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                deleteChat(index);
                                            }}
                                        >
                                            <DeleteIcon />
                                        </Box>
                                    )}
                                </Box>
                            ))}
                        </Box>
                    </>
                )}

                {currentUser && (
                    <Box className="sidebar-profile">
                        <UserProfile extend={extend || !isTablet || (isMobile && sidebarOpen)} />
                    </Box>
                )}
            </Box>
        </>
    );
}

export default Sidebar;
